import { useMove } from "@mantine/hooks";
import { useTheme } from "../../../../common/hooks";

export function VerticalSlider(props) {
  const {
    theme: { volumeSlider },
  } = useTheme();
  const { value, setValue } = props;
  const { ref } = useMove(({ y }) => setValue(1 - y));
  const transition = "background-color 1s ease-in-out";

  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: volumeSlider.fill,
        position: "relative",
        borderRadius: "500px",
        overflow: "hidden",
        transition,
      }}
    >
      {/* Filled bar */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          height: `${value * 100}%`,
          width: "100%",
          backgroundColor: volumeSlider.bg,
          transition,
        }}
      />

      {/* Thumb */}
      <div
        style={{
          position: "absolute",
          bottom: `calc(${value * 100}% - 8px)`,
          left: 0,
          width: 16,
          height: 16,
          opacity: 0,
        }}
      />
    </div>
  );
}
